import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-live",
  "use": "icon-live-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-live\"><defs><style type=\"text/css\"></style></defs><path d=\"M796.444 515.556l130.674-57.999a28.444 28.444 0 0 1 39.993 25.999v317.44a28.444 28.444 0 0 1-39.993 26.026l-130.674-58.026v84.337a56.889 56.889 0 0 1-56.888 56.89H113.778a56.889 56.889 0 0 1-56.89-56.89v-455.11a56.889 56.889 0 0 1 56.89-56.89h625.778a56.889 56.889 0 0 1 56.888 56.89v117.333zM497.778 312.889a99.556 99.556 0 1 1 0-199.111 99.556 99.556 0 0 1 0 199.11z m-199.111 0a71.111 71.111 0 1 1 0-142.222 71.111 71.111 0 0 1 0 142.222z m42.666 426.667a28.444 28.444 0 0 0 42.553 24.69l199.111-113.778a28.444 28.444 0 0 0 0-49.38L383.887 487.31A28.444 28.444 0 0 0 341.332 512v227.556z m56.89-178.546l113.322 64.768-113.323 64.768V561.01z\" fill=\"#B5B6B6\" p-id=\"2347\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/live.svg
// module id = ZkmS
// module chunks = 4